if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span:not(.product-form__submit-icon)');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const mainVariantId = formData.get('id');
        const tdCheckedAddOns = document.querySelectorAll('.td-product-card__checkbox:checked');
        if (tdCheckedAddOns.length > 0 && mainVariantId) {
          const mainQuantity = formData.get('quantity') || '1';
          formData.delete('id');
          formData.delete('quantity');
          formData.append('items[0][id]', mainVariantId);
          formData.append('items[0][quantity]', mainQuantity);
          tdCheckedAddOns.forEach((addOn, index) => {
            formData.append(`items[${index + 1}][id]`, addOn.value);
            formData.append(`items[${index + 1}][quantity]`, mainQuantity);
          });
        }

        const formattedModsNote = this.getFormattedTdCartNote();

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return null;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return null;
            }

            if (!formattedModsNote) return response;

            return this.appendTdCartNote(formattedModsNote).then((updatedCart) => {
              if (updatedCart?.sections) response.sections = updatedCart.sections;
              return response;
            });
          })
          .then((response) => {
            if (!response) return;

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (response.items && response.key === undefined) {
              response.key = response.items[0].key;
              response.id = response.items[0].id;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      getCartJsUrl() {
        const cartUrl = window.routes?.cart_url || '/cart';
        return `${String(cartUrl).replace(/\/$/, '')}.js`;
      }

      getFormattedTdCartNote() {
        const parts = [];

        const texts = [];
        document.querySelectorAll('.td-product-card__checkbox:checked').forEach((checkbox) => {
          const textarea = checkbox.closest('.td-product-card')?.querySelector('.td-product-card__textarea');
          const value = textarea?.value?.trim();
          if (value) texts.push(value);
        });
        if (texts.length) {
          const title = (
            document.querySelector('.td-product-card[data-product-title]')?.dataset.productTitle || ''
          ).trim();
          const lines = ['---'];
          if (title) lines.push(`Product: ${title}`);
          lines.push('Custom Tuning Mods List:');
          lines.push(texts.join('\n\n'));
          lines.push('---');
          parts.push(lines.join('\n'));
        }

        const vehicleInfoNote = this.getFormattedTdVehicleInfoNote();
        if (vehicleInfoNote) parts.push(vehicleInfoNote);

        return parts.join('\n');
      }

      formatTdTireSize(width, aspect, rim) {
        const widthValue = width?.trim();
        const aspectValue = aspect?.trim();
        const rimValue = rim?.trim();
        if (!widthValue && !aspectValue && !rimValue) return '';

        const rimFormatted = rimValue
          ? /^r/i.test(rimValue)
            ? rimValue.toUpperCase()
            : `R${rimValue}`
          : '';

        return [widthValue, aspectValue, rimFormatted].filter(Boolean).join(' / ');
      }

      getFormattedTdVehicleInfoNote() {
        const tireCard = document.querySelector('.td-prepurchase-vin--with-tires');
        if (tireCard) {
          const title = (tireCard.dataset.productTitle || '').trim();
          const vin = tireCard
            .querySelector('.td-prepurchase-vin__input:not(.td-prepurchase-vin__tire-input)')
            ?.value?.trim()
            .toUpperCase();
          const tireSize = this.formatTdTireSize(
            tireCard.querySelector('[data-tire-part="width"]')?.value,
            tireCard.querySelector('[data-tire-part="aspect"]')?.value,
            tireCard.querySelector('[data-tire-part="rim"]')?.value
          );

          if (!vin && !tireSize) return '';

          const lines = ['---'];
          if (title) lines.push(`Product: ${title}`);
          if (vin) lines.push(`VIN: ${vin}`);
          if (tireSize) lines.push(`Tire size: ${tireSize}`);
          lines.push('---');
          return lines.join('\n');
        }

        const vinCard = document.querySelector('.td-prepurchase-vin:not(.td-prepurchase-vin--with-tires)');
        const vinInput = vinCard?.querySelector('.td-prepurchase-vin__input');
        const vin = vinInput?.value?.trim().toUpperCase();
        if (!vin) return '';

        const title = (vinCard.dataset.productTitle || '').trim();
        const lines = ['---'];
        if (title) lines.push(`Product: ${title}`);
        lines.push(`VIN: ${vin}`);
        lines.push('---');
        return lines.join('\n');
      }

      fetchCartState() {
        return fetch(this.getCartJsUrl(), { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
            return response.json();
          })
          .catch((error) => {
            console.error(error);
            return null;
          });
      }

      appendTdCartNote(addition) {
        return this.fetchCartState()
          .then((cartState) => {
            if (!cartState) return null;

            const current = String(cartState.note || '').trimEnd();
            const nextNote = current ? `${current}\n${addition}` : addition;
            const payload = { note: nextNote };

            if (this.cart?.getSectionsToRender) {
              payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
              payload.sections_url = window.location.pathname;
            }

            return fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              body: JSON.stringify(payload),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.status) {
                  console.error(data);
                  return null;
                }
                return data;
              });
          })
          .catch((error) => {
            console.error(error);
            return null;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
